<template>
<v-app>
    <v-snackbar v-model="snackbar" top color="red" :timeout="4000">
        {{ errorMsg }}
        <v-btn color="white" icon @click="snackbar = false">
            <v-icon>mdi-close</v-icon>
        </v-btn>
    </v-snackbar>
    <v-form>
        <v-select :items="modeles" label="Modèles" item-text="name" item-value="id" v-model="selectedModele" dense outlined></v-select>
        <v-select :items="versions" label="Versions" item-text="nom" item-value="id" v-model="selectedVersion" dense outlined></v-select>
        <v-select :items="peinture" label="Peinture métalisé" item-text="value" item-value="key" v-model="selectedPeinture" dense outlined></v-select>
        <v-select :items="filterApport" label="Apport" v-if="(type == 'BMCI' && index !== 0 && index !== 5 && index !== 6) || type == 'VIVALIS'" item-text="value" item-value="key" dense outlined v-model="selectedApport"></v-select>
        <v-text-field label="Apport Client TTC" type="number" v-if="(type == 'BMCI' && index !== 0 && index !== 1 && index !== 2)" dense outlined v-model="apportValue" :disabled="index === 3 || index === 4"></v-text-field>
        <v-text-field label="Remise" type="number" dense outlined v-model="remise"></v-text-field>
        <v-text-field disabled label="Prix de Véhicule TTC" type="number" dense outlined v-model="montant"></v-text-field>
    </v-form>
</v-app>
</template>

<script>
export default {
    name: 'FormSimulateurCredit',
    data() {
        return {
            montant: 0,
            selectedPeriode: this.periodeId,
            remise: 0,
            modeles: [],
            versions: [],
            selectedModele: "0",
            selectedVersion: 0,
            selectedTarif: {},
            peinture: [{
                key: "Y",
                value: "Oui"
            }, {
                key: "N",
                value: "Non"
            }],
            selectedPeinture: "N",
            selectedApport: 0,
            apportValue: 0,
            apport: [{
                key: 0,
                value: '0 %'
            }, {
                key: 5,
                value: '5 %'
            }, {
                key: 10,
                value: '10 %'
            }, {
                key: 15,
                value: '15 %'
            }, {
                key: 20,
                value: '20 %'
            }, {
                key: 25,
                value: '25 %'
            }, {
                key: 30,
                value: '30 %'
            }, {
                key: 35,
                value: '35 %'
            }, {
                key: 40,
                value: '40 %'
            }, {
                key: 45,
                value: '45 %'
            }, {
                key: 50,
                value: '50 %'
            }],
            snackbar: false,
            errorMsg: ''
        }
    },
    async mounted() {
        if (this.tarif !== undefined) {
            this.$store.commit('SET_MODELE', this.tarif.version.hmodele.toString())
        }
        if (this.selectedPeriode == undefined) {
            await this.getPeriodeHistory()
        }

        this.getModeles()
        this.selectedModele = this.$store.state.simulateur.selectedModele
        this.selectedVersion = this.$store.state.simulateur.selectedVersion
        this.selectedPeinture = this.$store.state.simulateur.selectedPeinture
        this.selectedApport = this.$store.state.simulateur.selectedApport
        this.apportValue = this.$store.state.simulateur.apport
        this.remise = this.$store.state.simulateur.remise
    },
    watch: {
        selectedModele: async function (modeleId) {
            this.$store.commit('SET_MODELE', modeleId.toString())
            let data = await this.getVersions(modeleId)
            this.versions = data.data.data
            if (this.tarif !== undefined) {
                this.selectedVersion = this.tarif.version.id
                this.$store.commit('SET_VERSION', parseInt(this.tarif.version.id))
            }
        },
        selectedVersion: async function (versionId) {
            this.$store.commit('SET_VERSION', parseInt(versionId))
            let data = await this.getTarifVersion(versionId)
            this.selectedTarif = data.data.data[0]
            if (this.index == 3 && this.type == 'BMCI') {
                let tmp = ((this.selectedApport / 100) * this.selectedTarif.pvttc) + (((0.06 / 100) * 1.1) * ((1 - (this.selectedApport / 100)) * this.selectedTarif.pvttc))
                this.apportValue = tmp.toFixed(2)
            }
            if (this.index == 4 && this.type == 'BMCI') {
                let tmp = ((this.selectedApport / 100) * this.selectedTarif.pvttc)
                this.apportValue = tmp.toFixed(2)
            }
            this.montant = this.selectedTarif.pvttc - this.remise
            this.$store.commit('SET_MONTANT', parseFloat(this.montant))
        },
        remise: function (value) {
            this.$store.commit('SET_MONTANT', parseFloat(value))
            this.montant = this.selectedTarif.pvttc - value
            this.$store.commit('SET_MONTANT', parseFloat(this.montant))
        },
        selectedPeinture: function (value) {
            this.$store.commit('SET_PEINTURE', value.toString())
            switch (value) {
                case 'Y':
                    this.montant = this.selectedTarif.pvttc + this.selectedTarif.peinturemetallisee - this.remise
                    this.$store.commit('SET_MONTANT', parseFloat(this.montant))
                    break;
                case 'N':
                    this.montant = this.selectedTarif.pvttc - this.remise
                    this.$store.commit('SET_MONTANT', parseFloat(this.montant))
                    break;
            }
        },
        selectedApport: function (value) {
            this.$store.commit('SET_APPORT', parseInt(value))
            if (this.index == 3 && this.type == 'BMCI') {
                let tmp = ((value / 100) * this.selectedTarif.pvttc) + (((0.06 / 100) * 1.1) * ((1 - (value / 100)) * this.selectedTarif.pvttc))
                this.apportValue = tmp.toFixed(2)
            }
            if (this.index == 4 && this.type == 'BMCI') {
                let tmp = ((value / 100) * this.selectedTarif.pvttc)
                this.apportValue = tmp.toFixed(2)
            }
        },
        apportValue: function (value) {
            this.$store.commit('SET_APPORTVALUE', parseInt(value))
        },
        index: function (value) {
            if (this.selectedTarif != {}) {
                if (value == 3 && this.type == 'BMCI') {
                    let tmp = ((this.selectedApport / 100) * this.selectedTarif.pvttc) + (((0.06 / 100) * 1.1) * ((1 - (this.selectedApport / 100)) * this.selectedTarif.pvttc))
                    this.apportValue = tmp.toFixed(2)
                }
                if (value == 4 && this.type == 'BMCI') {
                    let tmp = ((this.selectedApport / 100) * this.selectedTarif.pvttc)
                    this.apportValue = tmp.toFixed(2)
                }
                if (value == 5 && this.type == 'BMCI') {
                    this.apportValue = 0
                }
                if (value == 6 && this.type == 'BMCI') {
                    let tmp = (0.2 * this.selectedTarif.pvttc)
                    this.apportValue = tmp.toFixed(2)
                }
            }
            if (isNaN(this.apportValue)) {
                this.apportValue = 0
            }
        }
    },
    props: ['tarif', 'index', 'type', 'periodeId'],
    methods: {
        getModeles: function () {
            let params = {}
            params.action = 'getModeles'
            this.axios.post(this.$store.state.rootUrl + 'apiSalesTarifier.php', params)
                .then(data => {
                    this.modeles = data.data.data
                })
                .catch(error => {
                    this.errorMsg = 'Oups Erreur Serveur. Veuillez réessayer dans quelques instants'
                    this.snackbar = true
                    console.log(error)
                })
        },
        getVersions: async function (modeleId) {
            let params = {}
            params.action = 'getModeleVersions'
            params.modeleId = modeleId
            return this.axios.post(this.$store.state.rootUrl + 'apiSalesTarifier.php', params)
        },
        getTarifVersion: async function (versionId) {
            let params = {}
            params.action = 'getTarifVersion'
            params.versionId = versionId
            params.type = 'VP'
            params.periodeId = this.selectedPeriode
            return this.axios.post(this.$store.state.rootUrl + 'apiSalesTarifier.php', params)
        },
        async getPeriodeHistory() {
            let params = {}
            params.action = 'getPeriodeHistory'
            await this.axios
                .post(this.$store.state.rootUrl + 'apiSalesTarifier.php', params)
                .then((data) => {
                    if (data.data.error === true) {
                        this.errorMsg = ''
                        this.snackbar = true
                        this.loading = false
                        return false
                    }
                    this.selectedPeriode = data.data.data[0].id;
                })
                .catch((error) => {
                    this.errorMsg = 'Oups Erreur Serveur. Veuillez réessayer dans quelques instants'
                    this.snackbar = true
                    console.log(error)
                })
        }
    },
    computed: {
        filterApport() {
            let data = []
            this.apport.forEach(element => {
                if (this.type == 'VIVALIS') {
                    if (element.key % 2 == 0) {
                        data.push(element);
                    }
                }
                if (this.type == 'BMCI' && this.index == 1) {
                    if (this.selectedApport == 0) {
                        this.selectedApport = 10
                    }
                    if (element.key % 2 == 0 && element.key != 0) {
                        data.push(element);
                    }
                }
                if (this.type == 'BMCI' && this.index == 2) {
                    if (this.selectedApport == 0 || this.selectedApport == 10) {
                        this.selectedApport = 20
                    }
                    if (element.key % 2 == 0 && element.key != 0 && element.key != 10) {
                        data.push(element);
                    }
                }
                if (this.type == 'BMCI' && this.index == 3) {
                    data.push(element);
                }
                if (this.type == 'BMCI' && this.index == 4) {
                    if (this.selectedApport == 0 || this.selectedApport == 5 || this.selectedApport == 10 || this.selectedApport == 15) {
                        this.selectedApport = 20
                    }
                    if (element.key != 0 && element.key != 5 && element.key != 10 && element.key != 15) {
                        data.push(element);
                    }
                }
            })
            return data;
        }
    }
}
</script>
